export default {
      id: "icon-cross-usage",
      viewBox: "0 0 96 96",
      url: "/" + "assets/sprite.svg#icon-cross",
      toString: function () {
        return this.url;
      }
    }